import keyNames from "../../keyName";
export const initialState = {
  [keyNames.themeMode]: "light",
  [keyNames.apiErrors]: null,
  [keyNames.extra]: null,
  [keyNames.isLoading]: "noLoading",
  [keyNames.toastData]: null,
  [keyNames.userData]: null,
  [keyNames.forceLogOut]: false,
  [keyNames.allUsers]: null,
  [keyNames.dashboardStats]: null,
  [keyNames.userDetail]: null,
  [keyNames.exportData]: null,
  [keyNames.businessCategories]: null,
  [keyNames.bulkUploadResult]: null,
  [keyNames.attendeeTypes]: null,
};
